import React from 'react';
import { ButtonType } from '~common/components/button/button.helper';
import { StateButton, StateButtonProps } from '~common/components/button/state-button.component';

export const FormButton: React.FunctionComponent<StateButtonProps> = ({
  children,
  type = ButtonType.SUBMIT,
  ...rest
}) => (
  <StateButton type={type} {...rest}>
    {children}
  </StateButton>
);



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/common/src/components/button/form-button.component.tsx